import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { ResponseSearchOrdersTable } from '../_models/search-orders'
import {
  ResponseViewProcessordersTable,
  ResponseViewProcessordersTableExportData
} from '../_models'

@Injectable({
  providedIn: 'root'
})
export class SearchTableSearchOrdersService {
  constructor (private _httpClient: HttpClient) {}

  getRepoIssues (
    SelectCostumer: Number,
    startDate: string,
    endDate: string
  ): Observable<ResponseViewProcessordersTable[]> {
    const requestUrl = `${environment.apiUrl}/Shipping/PlaceOrderViewSearchOrders`
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
    var Request = {}
    Request['companyId'] = Number(json.companyIdWh)
    Request['customerId'] = SelectCostumer
    Request['from'] = startDate
    Request['to'] = endDate

    return this._httpClient.post<ResponseViewProcessordersTable[]>(
      requestUrl,
      Request,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      }
    )
  }

  getShippingSearchOrders (
    SelectCostumer: Number,
    startDate: string,
    endDate: string,
    status: Number
  ): Observable<ResponseViewProcessordersTable[]> {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    const requestUrl = `${
      environment.apiUrl
    }/Shipping/ShippingOrderViewSearchOrders?companyId=${Number(
      json.companyIdWh
    )}&customerId=${SelectCostumer}&from=${new Date(new Date(startDate)).toUTCString()}&to=${new Date(new Date(endDate)).toUTCString()}&status=${status}`
  

   console.log('entroo')

    return this._httpClient.get<ResponseViewProcessordersTable[]>(
      requestUrl,
    
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      }
    )
  }
  getRepoIssueseDataExport (
    SelectCostumer: Number,
    startDate: string,
    endDate: string,
    status: string
  ): Observable<ResponseViewProcessordersTableExportData[]> {
    const requestUrl = `${environment.apiUrl}/Shipping/ShipingOrderExportDataItems`
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
    var Request = {}
    Request['companyId'] = Number(json.companyIdWh)
    Request['customerId'] = SelectCostumer
    Request['from'] = startDate
    Request['to'] = endDate
    Request['status'] = status

    return this._httpClient.post<ResponseViewProcessordersTableExportData[]>(
      requestUrl,
      Request,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      }
    )
  }
}
